import { FileText, Download } from "lucide-react"

// Shared download-row list for course-level files (legacy Bubble imports —
// external URLs). Used by the member course page and the coach course-detail
// card; callers own the surrounding wrapper/heading. The coach Content
// preview dialog intentionally uses a denser inline-link style instead.
export function CourseFilesList({ files = [] }) {
  if (!files.length) return null

  return (
    <div className="space-y-2">
      {files.map((file) => (
        <a
          key={file.id}
          href={file.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 px-4 py-3 rounded-lg border border-zinc-200 bg-white hover:border-kf-red/30 hover:shadow-sm transition-all group"
        >
          <div className="flex items-center justify-center h-8 w-8 rounded-full bg-zinc-100 shrink-0 group-hover:bg-kf-red/10">
            <FileText className="h-4 w-4 text-zinc-500 group-hover:text-kf-red" />
          </div>
          <span className="flex-1 text-sm font-medium text-zinc-900 truncate">{file.title}</span>
          <Download className="h-4 w-4 text-zinc-400 group-hover:text-kf-red shrink-0" />
        </a>
      ))}
    </div>
  )
}
